// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.
// Import CSS
import "../css/index.css";
import { initArticleVisits } from "./articleVisits";
// Import JS
import { initCookieConsent, isConsentGiven } from "./cookieConsent";
import initMenuOpen from "./drawerMenu";
import { initHeaderScroll } from "./headerScroll";
import infiniteScroll from "./infiniteScroll";
import { initRssFeed } from "./rssFeed";
import { initStockTicker } from "./stockTicker";
import { initTrendingPosts } from "./trendingPosts";

// Initialize all functionality when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Call the menu and infinite scroll functions
  initMenuOpen();
  infiniteScroll();

  // Initialize header scroll behavior (auto-hide on scroll)
  initHeaderScroll();

  // Initialize cookie consent
  initCookieConsent();

  // Initialize article visits
  if (isConsentGiven()) {
    initArticleVisits();
  }
  // Initialize stock ticker
  initStockTicker();

  // Initialize trending posts
  initTrendingPosts();

  // Latest Eulerpool News Agency stories (outbound links)
  initRssFeed({
    feedUrl: "https://aa-feeds.alleaktien.workers.dev/eulerpool",
    containerId: "eulerpool-container",
    categoryLabel: "Eulerpool News",
    cacheKey: "eulerpoolFeedData2",
    cacheTimeKey: "eulerpoolFeedTime2",
    articleCount: 4,
  });

  // Latest AlleAktien analyses (outbound links)
  initRssFeed({
    feedUrl: "https://aa-feeds.alleaktien.workers.dev/alleaktien",
    containerId: "alleaktien-container",
    categoryLabel: "AlleAktien",
    cacheKey: "alleaktienFeedData2",
    cacheTimeKey: "alleaktienFeedTime2",
    articleCount: 4,
  });
});
